<template>
	<div class="w-full bg-white h-screen">
		<div class="2xl:max-w-7xl xl:max-w-7xl mx-auto  ">
			<div class=" flex items-center text-[14px] ">
				<!-- <label class="text-[#101010]  mr-2 cursor-pointer">简体中文</label> -->
				<el-select v-model="value" :placeholder="langInfo.please_select" @change="changeLang">
					<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
					</el-option>
				</el-select>
				<!-- <img class="size-2.5 mr-5" src="@/static/image/icon01.png" alt="" srcset="" /> -->
				<div v-if="JSON.stringify(userInfo)=='{}'" class="text-[#FF0000] flex items-center">
					<label class="cursor-pointer" @click="goLogin()">{{langInfo.head_login}}～</label>
					<label></label>
					<label class="cursor-pointer" @click="goRegister()">｜{{langInfo.head_reg}}</label>
				</div>
				<div v-else class="text-[#FF0000] flex items-center">
					{{langInfo.head_welcome}}，{{userInfo.username}}～
				</div>
				<label v-if="userInfo.id" class="text-black cursor-pointer" @click="logOutClick()">｜
					{{langInfo.head_login_out}}</label>
			</div>
		</div>
		<div class="2xl:max-w-7xl flex justify-between mx-auto ">
			<div class="chat_left flex flex-col w-[360px] h-[70vh] ">
				<div class="flex-1 flex flex-col overflow-hidden pr-[20px] box-border">
					<div class="h-[82px] text-left leading-[82px] font-bold text-[#101010] text-[24px]">
						{{langInfo.chat_title}}
					</div>
					<div class="text-[14px] text-[#6C6C6C] mb-[16px]">
						{{langInfo['Historical Conversation']}}
					</div>
					<div class=" text-white  overflow-y-scroll mb-[16px]">
						<div @click="selectHistory(item,index)"
							:class="historyIndex==index?'bg-[#3761FF] text-white':'text-[#101010]'"
							class="flex justify-between cursor-pointer rounded-[12px] mb-[10px] py-[10px] px-[20px] box-border border border-solid border-[#ECECEC]"
							v-for="(item,index) in historyList" :key="index">
							<img src="@/static/image/icon72.png" class="w-[20px] h-[20px] mr-[12px]" alt="" />
							<div class="yw-text-cut-1 text-[16px] ">
								{{item.latest_content}}
							</div>
						</div>
					</div>
				</div>
				<div class="">
					<label @click="createNewChat()"
						class="text-[16px] cursor-pointer inline-block text-white min-w-[110px] h-[42px] bg-[#3761FF] leading-[42px] px-[10px] box-border text-center rounded-[12px] ">
						<i class="el-icon-plus"></i>
						{{langInfo['new Create Dialogue']}}
					</label>
				</div>

			</div>
			<div class="chat_right flex flex-col flex-1 h-[90vh]">
				<div class="py-[10px] box-border  bB-04 flex justify-end">
					<div
						class="text-[14px] text-[#101010] w-[110px] h-[36px] text-center leading-[36px] border border-solid border-[#E0E0E0] rounded-[12px]">
						{{langInfo.chat_title}}
					</div>
				</div>
				<div class="px-[40px] py-[20px] flex flex-col flex-1 overflow-hidden">
					<div ref="scrollContainer" class=" flex-1 box-border flex flex-col  mb-[54px] overflow-y-scroll">
						<div ref="listContainer" class="chat-messages ">
							<!-- 消息列表 -->
							<div v-for="(message, index) in messages" :key="message.id"
								:class="['message-item', message.role === 'user' ? 'my-message' : 'other-message']">
								<!-- 对方消息 -->

								<template v-if="message.role !== 'user'">
									<div class=" w-[80%] flex">
										<img src="@/static/image/icon75.png" class="w-[48px] h-[48px] mr-[12px]"
											srcset="" />

										<div class="message-content  flex flex-col flex-1 ">
											<div :class="message.content?'border border-solid border-[#E0E0E0]':''"
												class="p-[22px] mb-[10px] rounded-[16px] ">
												<div class="text-[#333333] text-[14px]">{{ displayContent(message) }}
												</div>
												<div class="typing-indicator" v-if="message.typing">
													<div class="dot"></div>
													<div class="dot"></div>
													<div class="dot"></div>
												</div>
											</div>
											<label v-if="message.type!='default'&&!message.typing"
												class="flex items-center justify-center rounded-[8px] py-[6px] box-border max-w-[96px]  border border-solid border-[#E0E0E0]">
												<img @click="regenerateClick(message, index)"
													v-if="historyIndex<0 &&  index == messages.length - 1"
													src="@/static/image/icon76.png"
													class="w-[20px] h-[20px] cursor-pointer mr-[20px]" srcset="" />
												<img @click="copyContent(message, index)"
													src="@/static/image/icon77.png"
													class="w-[20px] h-[20px] cursor-pointer" srcset="" />
											</label>
										</div>
									</div>
								</template>
								<!-- 我的消息 -->
								<template v-else>
									<div class="w-[80%] flex  justify-end">
										<div class="message-content my-content  mr-[12px]">
											<div class="message-bubble my-bubble p-[12px] box-border rounded-[16px]">
												<div>{{ message.content }}</div>
											</div>
										</div>
										<img :src="userInfo.avatar?userInfo.avatar:'@/static/image/index10.jpeg'"
											class="w-[40px] h-[40px] rounded-[50px] " alt="" srcset="" />
									</div>
								</template>
							</div>
						</div>
					</div>
					<div class="message_content p-[20px] box-border mb-[16px]">
						<el-input type="textarea" @input="inputClick" @keydown.enter.native="changeInput" :rows="3"
							resize="none" :placeholder="langInfo.phone_content_tip" maxlength="200"
							v-model="inputMessage">
						</el-input>
						<div class="flex items-center justify-between">

							<div class="">

							</div>
							<!-- <el-upload class="upload-demo" :action="$apiUrl+'api/v1.index/upload'"
								:on-preview="handlePreview" :on-remove="handleRemove" :before-remove="beforeRemove"
								multiple :limit="3" :http-request="httpRequest" :on-exceed="handleExceed"
								:file-list="fileList">
								<div class="cursor-pointer flex align-items-center text-[14px] text-[#4F4F4F]">
									<img src="@/static/image/icon73.png" class="w-[20px] h-[20px] mr-[6px]" alt=""
										srcset="" />
									上传图片
								</div>
							</el-upload> -->

							<div class="flex items-center text-[#101010]">
								<label class="mr-[12px]">{{messageLength}}/200</label>
								<div @click="sendMessage" :class="{ active: inputMessage.trim() }"
									class="w-[32px] h-[32px] cursor-pointer rounded-[4px] flex items-center justify-center send-btn">
									<img src="@/static/image/icon74.png" class="w-[20px] h-[20px]" alt="" srcset="" />
								</div>
							</div>
						</div>
					</div>
					<div class="text-[16px]">
						{{record_number}}｜ {{record_number}}<label v-if="copyright">｜{{copyright}}</label>
					</div>
				</div>

			</div>
		</div>
	</div>
</template>

<script>
	import axios from 'axios'
	export default {
		data() {
			return {
				options: [{
					value: 'zh',
					label: '' //中文
				}, {
					value: 'en',
					label: '' //英文
				}, {
					value: 'cht',
					label: '' //繁体
				}],
				value: 'zh',
				selectValue: '',
				userInfo: {},
				langInfo: {},

				inputMessage: '',
				messageLength: 0,
				showEmojiPanel: false,
				scrollTop: 0,
				loading: false,
				isSending: false,
				typingMessages: {}, // 存储正在打字的消息 {id: {content: '', index: 0}}
				typingSpeed: 30, // 打字速度(毫秒/字符)
				messagesPage: 1,
				messageTotal: 0,
				messages: [{
					id: 'msg_001',
					role: 'other',
					type: 'default',
					content: '', //你好呀！我是你的AI智能伙伴，你当前模式为通用问答，你可以这样问我：如：东方熊猫是什么？
					time: new Date().getTime()
				}],
				emojis: [
					'😀', '😃', '😄', '😁', '😆', '😅', '😂', '🤣', '😊', '😇',
					'🙂', '🙃', '😉', '😌', '😍', '🥰', '😘', '😗', '😙', '😚',
					'😋', '😛', '😝', '😜', '🤪', '🤨', '🧐', '🤓', '😎', '🤩',
					'🥳', '😏', '😒', '😞', '😔', '😟', '😕', '🙁', '☹️', '😣',
					'😖', '😫', '😩', '🥺', '😢', '😭', '😤', '😠', '😡', '🤬'
				],
				historyList: [],
				history_page: 1, //会话列表
				history_total: 0,
				historyIndex: -1,
				systemMessage: [],
				userFirstMessage: [],
				assistantList: [],
				session_id: '', //会话id
				fileList: [],
				headers: {
					"user-token": localStorage.getItem('token'),
					"server": 1
				},
				isLogin: true,
				record_number: '',
				copyright: ''
			}
		},
		computed: {
			today() {
				const date = new Date()
				return `${date.getFullYear()}年${date.getMonth() + 1}月${date.getDate()}日`
			},
			showDateDivider() {
				return this.messages.some(msg => {
					const msgDate = new Date(msg.time)
					const today = new Date()
					return (
						msgDate.getDate() === today.getDate() &&
						msgDate.getMonth() === today.getMonth() &&
						msgDate.getFullYear() === today.getFullYear()
					)
				})
			}
		},

		beforeDestroy() {
			// 组件销毁前清除所有打字计时器
			Object.values(this.typingMessages).forEach(msg => {
				if (msg.timer) {
					clearTimeout(msg.timer)
				}
			})
		},
		mounted() {
			this.getconfig()
			this.scrollToBottom()
			if (localStorage.getItem('userInfo')) {
				this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
			}

			this.getUserInfo()


			if (localStorage.getItem('session_id')) {
				this.session_id = localStorage.getItem('session_id')
			} else {
				this.session_id = new Date().getTime()
			}
			this.$api.getPrompt().then((res) => {
				console.log("Res");
				console.log(res);
				this.systemMessage = res.data
				console.log(this.systemMessage);
			})
			this.value = localStorage.getItem('lang') || 'zh';

			this.getdict_data()
		},
		methods: {
			getconfig() {
				// official_weChat=首页官方微信
				// download_app_image=下载二维码
				this.$api.config({}).then((res) => {
					console.log(res);

					this.copyright = res.data.copyright
					this.record_number = res.data.record_number

				}).catch((error) => {})
			},

			selectHistory(item, index) {
				this.historyIndex = index
				this.messagesPage = 1;
				this.messages = []
				this.messages = [{
					id: 'msg_001',
					role: 'system',
					type: 'default',
					content: '', //你好呀！我是你的AI智能伙伴，你当前模式为通用问答，你可以这样问我：如：东方熊猫是什么？
					time: new Date().getTime()
				}]
				this.messages[0].content = this.langInfo.system_tip
				this.session_id = item.session_id
				this.getHistory()
			},
			// 查询聊天记录
			getHistory() {

				let param = {
					session_id: this.session_id,
					limit: 10,
					page: this.messagesPage,
				}
				console.log(this.isLogin);
				if (!this.isLogin) {
					console.log("未登录");
					param.userId = new Date().getTime()
				}


				this.$api.getHistory(param).then((res) => {
					console.log("res.data====");
					console.log(res);

					if (this.messagesPage == 1) {
						this.messages = this.messages.concat(res.data.list)
						this.$nextTick(() => {
							this.scrollToBottom(true)
						})
					} else {
						const result = this.insertArrayAt(this.messages, 1, res.data.list);
						this.messages = result
					}
					this.messageTotal = res.data.total

				}).catch((error) => {
					console.log(error.msg);
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})
			},
			// 创建会话
			createNewChat() {
				if (this.messages.length == 1) {
					this.$common.showToastTip("已在新对话中")
				} else {
					this.messages = [{
						id: 'msg_001',
						role: 'system',
						content: '你好呀！我是你的AI智能伙伴，你当前模式为通用问答，你可以这样问我：如：东方熊猫是什么？',
						time: new Date().getTime()
					}]

					localStorage.getItem('session_id')

					this.session_id = new Date().getTime()
					this.historyIndex = -1
					this.history_page = 1;
					this.history_total = 0;
					this.historyList = []
					// 获取会话列表
					this.getSessions()
				}
			},
			getSessions() {

				let param = {
					limit: 20,
					page: this.history_page,
				}
				console.log(this.isLogin);
				if (!this.isLogin) {
					console.log("未登录");
					param.userId = new Date().getTime()
				}

				this.$api.getSessions(param).then((res) => {
					console.log("会话列表====");
					console.log(res);
					this.historyList = this.historyList.concat(res.data.list)
					this.history_total = res.data.total
				}).catch((error) => {
					this.$message({
						message: error.msg,
						type: 'warning'
					})

				})
			},
			changeLang(e) {
				console.log(e);
				this.selectValue = e
				this.dict_data_cq()
			},
			dict_data_cq() {
				this.$api.dict_data_cq({
					lang: this.selectValue
				}).then((res) => {
					console.log(res);
					if (res.code == 1) {
						this.value = this.selectValue
						this.selectValue = ""
						localStorage.setItem('lang', this.value)
						location.reload();
						this.getdict_data()
					} else {
						this.selectValue = localStorage.getItem('lang') || 'zh'
						this.value = localStorage.getItem('lang') || 'zh'
						this.$message({
							message: res.msg,
							type: 'warning'
						})
					}
				}).catch((error) => {
					this.selectValue = localStorage.getItem('lang') || 'zh'
					this.value = localStorage.getItem('lang') || 'zh'
					console.log("this.selectValue==" + this.selectValue);
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})
			},
			getdict_data() {
				this.$api.dict_data({}).then((res) => {
					console.log(res);
					const obj = {}
					res.data.forEach((item, index) => {
						obj[item.key] = item.value
					})
					this.langInfo = obj

					this.options[0].label = this.langInfo.zh
					this.options[1].label = this.langInfo.en
					this.options[2].label = this.langInfo.cht

					this.messages[0].content = this.langInfo.system_tip

				}).catch((error) => {})
			},
			getUserInfo() {
				this.$api.user_info().then((res) => {
					console.log(res.data);
					this.userInfo = res.data
					this.isLogin = true
					// 获取会话列表
					this.getSessions()
				}).catch((error) => {
					this.isLogin = false
					// 获取会话列表
					this.getSessions()
				})

			},
			showHistory() {
				this.$refs.historyPopup.open()
			},
			// 显示内容（实现打字机效果）
			displayContent(message) {

				if (message.role === 'user' || !message.id) {
					return message.content
				}

				// 如果是AI消息且有打字效果
				if (this.typingMessages[message.id]) {
					const typingMsg = this.typingMessages[message.id]
					return typingMsg.content.substring(0, typingMsg.index)
				}
				console.log(message.content);
				return message.content
			},

			inputClick(e) {
				console.log(e.length);
				this.messageLength = e.length
			},
			// 发送消息
			changeInput(event) {
				console.log("e=======");
				console.log(event);

				let e = window.event || arguments[0];
				// console.log(e,e.keyCode)
				if (e.key == "Enter" || e.code == "Enter" || e.keyCode == 13) {
					e.returnValue = false;
					this.sendMessage();
					return false;
				}


			},
			sendMessage() {
				console.log("this.inputMessage=====");
				console.log(this.inputMessage);
				if (!this.inputMessage.trim()) {

					this.$message({
						message: this.langInfo.phone_content_tip,
						type: 'warning'
					})

					return
				}

				this.isSending = true

				const newMessage = {
					id: 'msg_user_' + Date.now(),
					role: 'user',
					type: 'userSend',
					content: this.inputMessage,
					time: new Date().getTime()
				}

				this.messages.push(newMessage)
				const userMessage = this.inputMessage
				this.inputMessage = ''
				this.showEmojiPanel = false

				this.saveHistory(this.session_id, 'user', userMessage)


				this.$nextTick(() => {
					this.scrollToBottom(true)
				})

				// 添加AI正在输入中的状态
				const typingMessageId = 'msg_typing_' + Date.now()
				const typingMessage = {
					id: typingMessageId,
					role: 'system',
					content: '',
					save_id: '',
					typing: true,
					time: new Date().getTime()
				}

				this.messages.push(typingMessage)
				this.scrollToBottom(true)


				// 调用AI接口
				this.getAIResponse(userMessage).then(aiResponse => {
					// 移除正在输入状态，用打字机效果显示回复
					this.receiveReply(aiResponse, typingMessageId.replace('typing_', ''))
				}).catch(err => {
					console.error('AI请求失败:', err)
					// 移除正在输入状态的消息
					this.messages = this.messages.filter(msg => !msg.typing)
					// 添加错误提示（直接显示，不加打字效果）
					this.receiveReply('抱歉，我暂时无法处理您的请求，请替换你的key')
				}).finally(() => {
					this.isSending = false
				})
			},
			saveHistory(session_id, role, content) {
				let param = {
					session_id: session_id,
					role: role,
					content: content,
				}
				console.log(this.isLogin);
				if (!this.isLogin) {
					console.log("未登录");
					param.userId = new Date().getTime()
				}

				this.$api.saveHistory(param).then((res) => {
					console.log("res.data====");
					console.log(res.data.id);
					console.log(role);
					if (role == "deepseek") {
						this.$set(this.messages[this.messages.length - 1], 'save_id', res.data.id)
					}
					console.log("this.messages.length===");
					console.log(this.messages.length);
					if (this.messages.length == 3) {
						localStorage.setItem('session_id', session_id)

					}
				}).catch((error) => {
					console.log(error.msg);
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})
			},
			// 获取AI回复
			getAIResponse(userMessage) {
				return new Promise((resolve, reject) => {


					let user = {
						"role": "user",
						"content": userMessage
					}
					console.log(this.systemMessage);
					let messageList = this.systemMessage.concat([user])

					this.systemMessage = this.systemMessage.concat([user])



					axios.post('https://api.deepseek.com/chat/completions', {
							"model": "deepseek-chat",
							"messages": messageList,
							"frequency_penalty": 0,
							"max_tokens": 4096,
							"presence_penalty": 0,
							"response_format": {
								"type": "text"
							},
							"stop": null,
							"stream": false,
							"stream_options": null,
							"temperature": 1,
							"top_p": 1,
							"tools": null,
							"tool_choice": "none",
							"logprobs": false,
							"top_logprobs": null
						}, {
							headers: {
								'Authorization': 'Bearer sk-aafffc41440546d882805606d407c3f3',
								'Content-Type': 'application/json'
							}
						})
						.then(res => {
							if (res.data && res.data.choices && res.data.choices[0] && res.data
								.choices[0].message) {
								// 去掉回复中的换行符
								const replyContent = res.data.choices[0].message.content.replace(/\n/g,
									'')
								if (replyContent) {
									resolve(replyContent)


									let replyInfo = {
										"role": "assistant",
										"content": replyContent
									}

									this.saveHistory(this.session_id, 'deepseek', replyContent)

									this.systemMessage = this.systemMessage.concat([replyInfo])


								} else {
									reject(new Error('AI回复为空'))
								}
							} else {
								reject(new Error('无效的API响应'))
							}
						})
						.catch(error => {
							reject(error)
						});

				})
			},

			// 接收回复（修改为打字机效果）
			receiveReply(content, messageId) {
				// 移除正在输入状态的消息
				this.messages = this.messages.filter(msg => !msg.typing)

				const replyMessage = {
					id: messageId || ('msg_' + Date.now()),
					role: 'system',
					type: 'aiReply',
					content: content,
					time: new Date().getTime()
				}

				this.messages.push(replyMessage)
				this.scrollToBottom(true)

				// 如果是AI回复且内容不为空，启动打字机效果
				if (content && content.length > 0) {
					this.startTypingEffect(replyMessage.id, content)
				}
			},

			// 开始打字机效果
			startTypingEffect(messageId, fullContent) {
				// 初始化打字状态
				this.$set(this.typingMessages, messageId, {
					content: fullContent,
					index: 0,
					timer: null
				})

				// 开始打字
				const typeNextChar = () => {

					const typingMsg = this.typingMessages[messageId]
					if (!typingMsg) return

					if (typingMsg.index < typingMsg.content.length) {
						typingMsg.index++
						this.$forceUpdate() // 强制更新视图
						this.scrollToBottom(true)
						typingMsg.timer = setTimeout(typeNextChar, this.typingSpeed)
					} else {
						// 打字完成，清除状态
						console.log("this.typingMessages====");
						console.log(this.typingMessages);
						// delete this.typingMessages[messageId]
					}
				}
				// 延迟一点开始打字，让消息先显示出来
				setTimeout(typeNextChar, 300)
			},

			// 滚动到底部
			scrollToBottom(animate = false) {
				this.$nextTick(() => {
					let scrollContainer = this.$refs.scrollContainer;
					let listContainer = this.$refs.listContainer;
					console.log("scrollContainer.clientHeight==" + scrollContainer.clientHeight);
					if (listContainer.scrollHeight > scrollContainer.clientHeight) {
						scrollContainer.scrollTop = listContainer.scrollHeight; // 滚动到最底部
					}
				});

				// setTimeout(() => {
				// 	const query = uni.createSelectorQuery().in(this)
				// 	query.select('.chat-content').boundingClientRect()
				// 	query.select('.chat-messages').boundingClientRect()
				// 	query.exec(res => {
				// 		if (res[0] && res[1]) {
				// 			this.scrollTop = res[1].height - res[0].height
				// 			if (animate) {
				// 				// 添加平滑滚动效果
				// 				this.$forceUpdate()
				// 			}
				// 		}
				// 	})
				// }, 50)
			},

			// 加载更多消息
			loadMoreMessages() {
				if (this.loading) return
				this.loading = true

				this.$message({
					message: this.langInfo.Loading,
					type: 'warning'
				})

				// 模拟加载更多消息
				setTimeout(() => {
					this.loading = false
					uni.hideLoading()
					if (this.messages.length - 1 >= this.messageTotal) {
						return
					}
					this.messagesPage++
					this.getHistory()

				}, 800)
			},

			// 切换表情面板
			toggleEmojiPanel() {
				this.showEmojiPanel = !this.showEmojiPanel
				if (this.showEmojiPanel) {
					this.scrollToBottom()
				}
			},

			hideEmojiPanel() {
				this.showEmojiPanel = false
			},

			// 插入表情
			insertEmoji(emoji) {
				this.inputMessage += emoji
			},

			// 格式化时间
			formatTime(timestamp) {
				const date = new Date(timestamp)
				const hours = date.getHours().toString().padStart(2, '0')
				const minutes = date.getMinutes().toString().padStart(2, '0')
				return `${hours}:${minutes}`
			},
			goLogin() {
				localStorage.removeItem('userInfo')
				localStorage.removeItem('token')
				this.$router.replace({ path: '/login' })
			},
			goRegister() {
				localStorage.removeItem('userInfo')
				localStorage.removeItem('token')
				this.$router.replace({ path: '/register' })
			},
			// 退出登录
			logOutClick() {

				this.$api.logout().then((res) => {
					console.log(res.data);
		localStorage.removeItem('userInfo')
				localStorage.removeItem('token')
				this.$router.push({ path: '/login' })
				}).catch((error) => {
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})
		
			},
			// 重新生成
			regenerateClick(item, index) {
				console.log(this.messages);
				this.deleteHistory(item)
				this.messages.splice(index, 1)

				console.log(this.systemMessage);
				this.systemMessage.splice(this.systemMessage.length - 1, 1)
				// 添加AI正在输入中的状态
				const typingMessageId = 'msg_typing_' + Date.now()
				const typingMessage = {
					id: typingMessageId,
					role: 'other',
					content: '',
					typing: true,
					time: new Date().getTime()
				}

				this.messages.push(typingMessage)
				this.scrollToBottom(true)

				this.regenerateAIResponse().then(aiResponse => {
					// 移除正在输入状态，用打字机效果显示回复
					this.receiveReply(aiResponse, typingMessageId.replace('typing_', ''))
				}).catch(err => {
					console.error('AI请求失败:', err)
					// 移除正在输入状态的消息
					this.messages = this.messages.filter(msg => !msg.typing)
					// 添加错误提示（直接显示，不加打字效果）
					this.receiveReply('抱歉，我暂时无法处理您的请求，请替换你的key')
				}).finally(() => {
					this.isSending = false
				})
			},


			deleteHistory(item) {
				console.log(item);
				let param = {
					id: item.save_id
				}
				console.log(this.isLogin);
				if (!this.isLogin) {
					console.log("未登录");
					param.userId = new Date().getTime()
				}
				this.$api.deleteHistory(param).then((res) => {
					console.log("删除会话记录=====");
					console.log(res);
				}).catch((error) => {
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})
			},

			regenerateAIResponse() {
				return new Promise((resolve, reject) => {
					let messageList = this.systemMessage
					axios.post('https://api.deepseek.com/chat/completions', {
							"model": "deepseek-chat",
							"messages": messageList,
							"frequency_penalty": 0,
							"max_tokens": 4096,
							"presence_penalty": 0,
							"response_format": {
								"type": "text"
							},
							"stop": null,
							"stream": false,
							"stream_options": null,
							"temperature": 1,
							"top_p": 1,
							"tools": null,
							"tool_choice": "none",
							"logprobs": false,
							"top_logprobs": null
						}, {
							headers: {
								'Authorization': 'Bearer sk-8da5f93d45ae4e5b8a24ee0d5bb54459',
								'Content-Type': 'application/json'
							}
						})
						.then(res => {
							if (res.data && res.data.choices && res.data.choices[0] && res.data.choices[0]
								.message) {
								// 去掉回复中的换行符
								const replyContent = res.data.choices[0].message.content.replace(/\n/g, '')
								if (replyContent) {
									resolve(replyContent)
									let replyInfo = {
										"role": "assistant",
										"content": replyContent
									}
									this.saveHistory(this.session_id, 'deepseek', replyContent)
									this.systemMessage = this.systemMessage.concat([replyInfo])

								} else {
									reject(new Error('AI回复为空'))
								}
							} else {
								reject(new Error('无效的API响应'))
							}
						})
						.catch(error => {
							reject(error)
						});

				})

			},
			// 复制
			copyContent(item, index) {
				const textArea = document.createElement('textarea');
				textArea.value = item.content;
				textArea.style.position = 'fixed'; // 避免可见区域闪烁
				document.body.appendChild(textArea);
				textArea.select();
				// 尝试复制并处理可能的异常
				const success = document.execCommand('copy');
				document.body.removeChild(textArea);
				if (success) {
					this.statusMessage = "已成功复制到剪贴板！"; //（兼容模式）
					this.$message.success(this.statusMessage);

				} else {
					this.$message.success("复制方法失败");
				}
			},
		}
	}
</script>

<style scoped>
	.send-btn {
		background-color: rgba(56, 148, 255, 0.3);
		color: #ffffff;
		border-radius: 0 40rpx 40rpx 0;
		height: 80rpx;
		line-height: 80rpx;
		font-size: 28rpx;
		padding: 0 40rpx;
		border: none;
		transition: all 0.3s ease;


	}

	.send-btn.active {
		background-color: #3894FF;
		color: white;
		box-shadow: 0 2rpx 10rpx rgba(56, 148, 255, 0.3);
	}

	/deep/.el-input input {
		padding-right: 0;
		background-color: transparent;
		border: 0;
	}

	/deep/.el-input input {
		width: 80px;
	}

	/deep/textarea {
		border: none;
		padding: 0;
	}


	input {
		border: none;
		background-color: transparent;
	}

	input::placeholder {
		color: #A6A6A6;
		/* 例如，设置为灰色 */
	}

	.chat_left {
		border-right: 1px solid #E0E0E0;
	}

	::-webkit-scrollbar {
		display: none;
	}

	.message_content {
		border-radius: 16px;
		background-color: rgba(255, 255, 255, 1);
		color: rgba(255, 255, 255, 1);
		font-size: 14px;
		text-align: center;
		box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.03);
		border: 1px solid rgba(236, 236, 236, 1);
	}



	/* 聊天内容区域 */
	.chat-content {
		flex: 1;
		padding: 10px;
		box-sizing: border-box;
		overflow: hidden;
		background-color: #ffffff;
		background-image: radial-gradient(circle at 10% 20%, rgba(255, 218, 185, 0.1) 0%, transparent 20%),
			radial-gradient(circle at 90% 80%, rgba(255, 192, 203, 0.1) 0%, transparent 20%);
		position: relative;


	}

	.chat-content::-webkit-scrollbar {
		width: 2px;
	}

	.chat-content::-webkit-scrollbar-thumb {
		background-color: rgba(255, 107, 107, 0.5);
		border-radius: 2px;
	}

	.chat-content::-webkit-scrollbar-track {
		background-color: transparent;
	}

	.chat-messages {
		display: flex;
		flex-direction: column;
		justify-content: flex-end;
	}

	.time-divider {
		display: flex;
		justify-content: center;
		margin: 15px 0;

	}

	.time-divider text {
		background-color: rgba(0, 0, 0, 0.1);
		color: #666;
		font-size: 12px;
		padding: 4px 10px;
		border-radius: 10px;
		backdrop-filter: blur(6px);
	}

	.message-item {
		display: flex;
		margin-bottom: 20px;
		transition: all 0.3s ease;
		transform-origin: center bottom;

	}

	.message-item.my-message {
		justify-content: flex-end;
		animation: slideInRight 0.3s ease;
	}

	.message-item.other-message {
		justify-content: flex-start;
		/* background-color: #F6F5FA; */
		padding: 0 12px;
		box-sizing: border-box;
		animation: slideInLeft 0.3s ease;
		border-radius: 10px;
	}

	@keyframes slideInRight {
		from {
			opacity: 0;
			transform: translateX(25px);
		}

		to {
			opacity: 1;
			transform: translateX(0);
		}
	}

	@keyframes slideInLeft {
		from {
			opacity: 0;
			transform: translateX(-25px);
		}

		to {
			opacity: 1;
			transform: translateX(0);
		}
	}

	.message-avatar {
		width: 40px;
		height: 40px;
		border-radius: 50%;
		align-self: flex-end;
		margin: 0 10px;
		border: 1px solid rgba(255, 255, 255, 0.5);
		box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
		flex-shrink: 0;


	}

	.message-avatar.my-avatar {
		order: 1;
	}

	.message-content {}

	.message-bubble {
		padding: 8px 10px;
		border-radius: 10px;
		position: relative;
		font-size: 15px;
		line-height: 1.4;
		word-break: break-word;
		animation: bubbleIn 0.2s ease;

	}

	.message-bubble.my-bubble {
		background-color: #3761FF;
		border-top-right-radius: 0;
		color: #fff;
		box-shadow: 0 1px 4px rgba(149, 236, 105, 0.3);
	}

	.message-bubble:not(.my-bubble) {
		background-color: #fff;
		border-top-left-radius: 0;
		box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
	}

	/* 打字光标效果 */
	.message-bubble:after {
		content: '';
		position: absolute;
		right: -4px;
		bottom: 1px;
		width: 2px;
		height: 15px;
		background-color: #333;
		opacity: 0;
	}

	@keyframes bubbleIn {
		from {
			transform: scale(0.9);
			opacity: 0.8;
		}

		to {
			transform: scale(1);
			opacity: 1;
		}
	}

	@keyframes blinkCursor {

		0%,
		100% {
			opacity: 1;
		}

		50% {
			opacity: 0;
		}
	}

	.message-time {
		font-size: 11px;
		color: #999;
		margin-top: 4px;

	}

	.message-time.my-time {
		text-align: right;
	}


	.typing-indicator {
		display: flex;
		padding: 6px 0 0 0;


	}

	.typing-indicator .dot {
		width: 6px;
		height: 6px;
		background-color: #999;
		border-radius: 50%;
		margin-right: 4px;
		animation: typingAnimation 1.4s infinite ease-in-out;

	}

	.typing-indicator .dot:nth-child(1) {
		animation-delay: 0s;
	}

	.typing-indicator .dot:nth-child(2) {
		animation-delay: 0.2s;
	}

	.typing-indicator .dot:nth-child(3) {
		animation-delay: 0.4s;
		margin-right: 0;
	}

	@keyframes typingAnimation {

		0%,
		60%,
		100% {
			transform: translateY(0);
			opacity: 0.6;
		}

		30% {
			transform: translateY(-10rpx);
			opacity: 1;
		}
	}
</style>